import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import AdminSubHeader from "../../../layouts/partials/AdminSubheader";
import { RENTALS_ACTIONS } from "../../../../redux/rentals/actions";
import {
  selectRentals,
  rentalCreating,
  rentalsLoaded,
  rentalsMeta,
  selectActiveRental
} from "../../../../redux/rentals/selectors";
import RentalForm from "../../../forms/RentalForm";
import Confirm from "../../../../base/Confirm";
import ListView from "../../../../base/ListView";
import {
  selectEvent,
  selectLastRentedMaterial
} from "../../../../redux/preferences/selectors";
import { PREFERENCES_ACTIONS } from "../../../../redux/preferences/actions";
import {
  createRental,
  getRentals,
  returnRental
} from "../../../../services/api/rentals";
import { toImmutable } from "../../../../libs/immutable-transformer";
import ReturnBtn from "./ReturnBtn";
import { getEventMaterials } from "../../../../services/api/eventMaterials";
import { getCrewMembers } from "../../../../services/api/crewMembers";
import {
  ajaxErrorHandler,
  defaultSuccess,
  formatUTCDate
} from "../../../../libs/utils";
import { getMaterials } from "../../../../services/api/materials";
import ConfirmRental from "./ConfirmRental";

class _Rentals extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      rentals: this.props.rentals,
      activeRental: null,
      materials: [],
      rentalsLoaded: this.props.rentalsLoaded,
      baseFilters: toImmutable({
        "page[number]": 1,
        "page[size]": 50,
        sort: "-updated_at",
        include:
          "material,lent-by-crew-member,returned-by-crew-member,lent-by-crew-member.user,returned-by-crew-member.user,lent-by-crew-member.registration,lent-by-crew-member.registration.company"
      })
    };

    this._handleCreate = this._handleCreate.bind(this);
    this._handleDelete = this._handleDelete.bind(this);
    this._handleFilterUpdate = this._handleFilterUpdate.bind(this);
    this._loadRequests = this._loadRequests.bind(this);
    this._getMaterials = this._getMaterials.bind(this);
  }

  static propTypes = {
    rentals: PropTypes.array,
    rentalsLoaded: PropTypes.bool,
    loadRentals: PropTypes.func,
    match: PropTypes.object,
    createRental: PropTypes.func,
    updateRental: PropTypes.func,
    deleteRental: PropTypes.func,
    rentalCreating: PropTypes.bool,
    rentalsMeta: PropTypes.object,
    filters: PropTypes.object,
    updateFilters: PropTypes.func,
    loadRental: PropTypes.func,
    resetActiveRental: PropTypes.func,
    activeRental: PropTypes.object,
    event: PropTypes.object,
    lastRentedMaterial: PropTypes.string,
    setPreference: PropTypes.func
  };

  UNSAFE_componentWillMount() {
    this._getMaterials();
    if (this.props.event.id) {
      this._loadRequests();
    }

    if (this.props.match.params.id) {
      this.props.loadRental(this.props.match.params.id, this.props.event.id);
    } else {
      this.props.resetActiveRental();
    }
  }

  _loadRequests() {
    this.props.loadRentals(this.state.baseFilters, this.props.event.id);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.event.id !== nextProps.event.id) {
      this.props.loadRentals(undefined, nextProps.event.id);
    }

    if (this.props.match.params.id !== nextProps.match.params.id) {
      this.props.loadRental(nextProps.match.params.id);
    }
  }

  _getMaterials() {
    getMaterials({
      "page[number]": 0,
      "page[size]": 80
    }).then(response => {
      console.log("response", response.data);
      this.setState({
        materials: response.data
      });
    });
  }

  _handleFilterUpdate(filters) {
    this.props.loadRentals(filters, this.props.event.id);
    this.setState({
      baseFilters: filters
    });
  }

  _handleDelete(id) {
    Confirm(
      "Are you sure you want to delete this Rental? This action can not be undone, please make sure no festival is using this rental.",
      {
        title: "Delete Rental",
        confirmStyle: "btn-danger",
        confirmText: "Delete"
      }
    ).then(
      result => {
        this.props.deleteRental(id);
      },
      result => {}
    );
  }

  _handleCreate(values) {
    const self = this;
    return new Promise(function(resolve, reject) {
      self.props.setPreference("lastRentedMaterial", values.materialId);

      createRental(self.props.event.id, {
        lentByCrewMemberId: values.crewMemberId,
        materialId: values.materialId,
        code: values.code
      })
        .then(response => {
          defaultSuccess("Material Rented");
          self._loadRequests();
          resolve();
        })
        .catch(e => {
          if (
            e.response.data.message.indexOf("no approved material request") > -1
          ) {
            ConfirmRental(
              `There's no approved material request on this day for this crew member's company.`,
              {
                title: "No approved material request",
                confirmStyle: "btn-danger",
                confirmText: "Force Rent"
              }
            ).then(
              result => {
                console.log("result", result);
                createRental(self.props.event.id, {
                  lentByCrewMemberId: values.crewMemberId,
                  materialId: values.materialId,
                  code: values.code,
                  forced: true,
                  end_date: result.endDate
                })
                  .then(response => {
                    self._loadRequests();
                    defaultSuccess("Material Rented");
                  })
                  .catch(ajaxErrorHandler)
                  .then(() => {
                    resolve();
                  });
              },
              result => {
                resolve();
              }
            );
          } else if (
            e.response.data.message.indexOf("already been rented out") > -1
          ) {
            Confirm(
              `${e.response.data.message} You want to return it and rent it out again?.`,
              {
                title: "Already been rented out",
                confirmStyle: "btn-danger",
                confirmText: "Return and Rent out"
              }
            ).then(
              result => {
                getRentals(self.props.event.id, {
                  "filter[material_id]": values.materialId,
                  "filter[code]": values.code,
                  "filter[returned]": "false"
                }).then(response => {
                  let promises = [];

                  response.data.forEach(rental => {
                    promises.push(
                      returnRental(self.props.event.id, rental.id, {
                        returnedByCrewMemberId: rental.lentByCrewMemberId,
                        returnCondition: "perfect"
                      })
                    );
                  });

                  Promise.all(promises).then(responses => {
                    createRental(self.props.event.id, {
                      lentByCrewMemberId: values.crewMemberId,
                      materialId: values.materialId,
                      code: values.code
                    })
                      .then(response => {
                        self._loadRequests();
                        defaultSuccess("Material Rented");
                      })
                      .catch(e => {
                        if (
                          e.response.data.message.indexOf(
                            "no approved material request"
                          ) > -1
                        ) {
                          ConfirmRental(
                            `There's no approved material request on this day for this crew member's company.`,
                            {
                              title: "No approved material request",
                              confirmStyle: "btn-danger",
                              confirmText: "Force Rent",
                              label: "Select End Date"
                            }
                          ).then(
                            result => {
                              console.log("result", result);
                              createRental(self.props.event.id, {
                                lentByCrewMemberId: values.crewMemberId,
                                materialId: values.materialId,
                                code: values.code,
                                forced: true,
                                end_date: result.endDate
                              })
                                .then(response => {
                                  self._loadRequests();
                                  defaultSuccess("Material Rented");
                                })
                                .catch(ajaxErrorHandler)
                                .then(() => {
                                  resolve();
                                });
                            },
                            result => {
                              resolve();
                            }
                          );
                        } else {
                          ajaxErrorHandler(e);
                        }
                      })
                      .then(() => {
                        resolve();
                      });
                  });
                });
              },
              result => {
                resolve();
              }
            );
          } else {
            ajaxErrorHandler(e);
          }
        });
    });
  }

  render() {
    const { baseFilters, materials } = this.state;
    const {
      rentals,
      rentalsMeta,
      activeRental,
      event,
      lastRentedMaterial
    } = this.props;

    const listViewConf = {
      dataSet: rentals,
      dataMeta: rentalsMeta,
      columns: [
        {
          key: "material.name",
          value: "Material",
          sort: "material_id"
        },
        {
          key: "code",
          value: "Code",
          sort: "code"
        },
        {
          key: "lentByCrewMember.registration.company.name",
          value: "Company"
        },
        {
          key: "",
          value: "Rented By",
          render: item =>
            item.lentByCrewMember.user.firstName +
            " " +
            item.lentByCrewMember.user.lastName
        },
        {
          key: "lentAt",
          value: "From",
          sort: "lent_at",
          render: item => formatUTCDate(item.lentAt, "DD/MM HH:mm")
        },
        {
          key: "name",
          value: "Returned By",
          render: item => {
            if (item.returnedByCrewMember) {
              return (
                item.returnedByCrewMember.user.firstName +
                " " +
                item.returnedByCrewMember.user.lastName
              );
            }

            return "";
          }
        },
        {
          key: "returnedAt",
          value: "Untill",
          sort: "returned_at",
          render: item => {
            if (item.returnedAt) {
              return formatUTCDate(item.returnedAt, "DD/MM HH:mm");
            }

            return "";
          }
        },
        {
          key: "returnCondition",
          value: "Condition",
          render: item => {
            if (item.returnedByCrewMember) {
              if (item.returnCondition === "perfect") {
                return (
                  <div
                    className="m-badge m-badge--success m-badge--wide"
                    data-tip={item.returnRemark}
                  >
                    {item.returnCondition}
                  </div>
                );
              } else {
                return (
                  <div
                    className="m-badge m-badge--danger m-badge--wide"
                    data-tip={item.returnRemark}
                  >
                    {item.returnCondition}
                  </div>
                );
              }
            } else {
              return null;
            }
          }
        }
      ],
      baseFilters,
      filters: [
        {
          col: 4,
          label: "Code",
          icon: "la-search",
          type: "text",
          key: "code"
        },
        {
          col: 4,
          label: "Material",
          icon: "la-tag",
          type: "select",
          key: "material_id",
          dataset: materials.map(material => {
            return { key: material.id, value: material.name };
          })
        },
        {
          col: 4,
          label: "Status",
          icon: "la-tag",
          type: "select",
          key: "returned",
          dataset: [
            { key: "false", value: "Rented" },
            { key: "true", value: "Returned" }
          ]
        },
        {
          col: 6,
          label: "Company",
          icon: "la-building-o",
          type: "text",
          key: "lent_by_crew_member_company_name"
        },
        {
          col: "6",
          label: "Rented By",
          icon: "la-user",
          type: "typeahead",
          options: value =>
            getCrewMembers({
              "filter[event_id]": event.id,
              "filter[name_like]": value,
              include: "user,registration,registration.company"
            }),
          key: "lent_by_crew_member_id",
          labelKey: crewMember =>
            `${crewMember.user.firstName} ${crewMember.user.lastName} (${crewMember.registration.company.name})`
        }
      ],
      actions: {
        deleteLink: true,
        editLink: false,
        detailsLink: false,

        deleteFunction: this._handleDelete,
        customLink: item => {
          if (!item.returnedByCrewMember) {
            return <ReturnBtn item={item} reload={this._loadRequests} />;
          }

          return null;
        }
      },
      url: "/admin/rentals"
    };

    return [
      <AdminSubHeader title="Rentals" key="subheader" breadcrumbs={[]} />,
      <div className="m-content" key="content">
        <div className="row">
          <div className="col-xl-12">
            <div className="m-portlet">
              <div className="m-portlet__head">
                <div className="m-portlet__head-caption">
                  <div className="m-portlet__head-title">
                    <span className="m-portlet__head-icon">
                      <i className="flaticon-map-location" />
                    </span>
                    <h3 className="m-portlet__head-text">
                      {activeRental ? "Edit Rental" : "Create Rental"}
                    </h3>
                  </div>
                </div>
              </div>
              <RentalForm
                onSubmit={this._handleCreate}
                event={event}
                materials={materials}
                lastRentedMaterial={lastRentedMaterial}
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-xl-12">
            <ListView
              config={listViewConf}
              handleDelete={this._handleDelete}
              handleFilterUpdate={this._handleFilterUpdate}
            />
          </div>
        </div>
      </div>
    ];
  }
}

const mapDispatchToProps = dispatch => ({
  loadRentals: (params, eventId) =>
    dispatch(RENTALS_ACTIONS.loadAllRequest(params, eventId)),
  loadRental: (id, eventId) =>
    dispatch(RENTALS_ACTIONS.loadRequest(id, eventId)),
  resetActiveRental: () => dispatch(RENTALS_ACTIONS.resetActive()),
  createRental: (values, eventId) =>
    dispatch(RENTALS_ACTIONS.createRequest(values, eventId)),
  updateRental: (id, values, eventId) =>
    dispatch(RENTALS_ACTIONS.updateRequest(id, values, eventId)),
  deleteRental: (id, eventId) =>
    dispatch(RENTALS_ACTIONS.deleteRequest(id, eventId)),
  updateFilters: filters => dispatch(RENTALS_ACTIONS.updateFilters(filters)),
  setPreference: (key, value) =>
    dispatch(PREFERENCES_ACTIONS.setPreference(key, value))
});

const mapStateToProps = function(state) {
  return {
    rentals: selectRentals(state),
    rentalsLoaded: rentalsLoaded(state),
    rentalCreating: rentalCreating(state),
    rentalsMeta: rentalsMeta(state),
    activeRental: selectActiveRental(state),
    event: selectEvent(state),
    lastRentedMaterial: selectLastRentedMaterial(state)
  };
};

const Rentals = connect(mapStateToProps, mapDispatchToProps)(_Rentals);

export default Rentals;
